import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Card } from 'react-bootstrap';
import TournoisAffichageParticiper from './tournoisAffichageParticiper';
import TournoisAffichageGestion from './tournoisAfficherGestion';
import TournoisAffichageInscrit from './tournoisAffichageInscrit';
import TournoisAffichageAncien from './tournoisAffichageAncien';

const TournoisAffichageCoach = (props) => {
    const [tournois, setTournois] = useState();
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const apiUrl = process.env.REACT_APP_API_URL;

    

    useEffect(() => {
        setIsLoading(true);
        const fetchData = async () => {
          try {
            const response = await axios.get(
              `${apiUrl}/tournois/affichage/${props.userData.user.donnée.results[0].id_equipe}`,
              {
                withCredentials: true 
              }
            );
            setTournois(response.data);
            setError(null);
            setIsLoading(false);
            
    
          } catch (error) {
            if (error.response) {
                
              setError(error.response.data.message);
            } else {
           
              setError(true)
            }
            setIsLoading(false);
    
          }
        };
    
        fetchData(); 
      }, [apiUrl, props.userData.user.donnée.results]);


      if (isLoading) {
        return (
        <div className="centered-content">
          <img src="/img/logo.png" alt="Logo" className="centered-logo" />
          <br/>
          <span className="loader"></span>
        </div>
        
        );  
      }
      if(error){
          return (
              <>
              <div id="alert-message" className="alert4" >
                  <strong>ERROR ! </strong>{error} <span id="alert-text"></span>
              </div>
            </>  
          )
      }

  return (
    <>
            {tournois ? (
            <>
                <Card.Title as="h3" className="mb-0"><strong>S'inscrire à un tournoi</strong></Card.Title>
                <hr/>
                <br/>
                <TournoisAffichageParticiper userData={props.userData} tournoisPasInscrit={tournois.tournoisPasInscrit}/>
                <Card.Title as="h3" className="mb-0"><strong>Tournois inscrit</strong></Card.Title>
                <hr/>
                <br/>
                <TournoisAffichageInscrit userData={props.userData} tournoisInscrit={tournois.tournoisInscrit}/>
                <Card.Title as="h3" className="mb-0"><strong>Vos tournois</strong></Card.Title>
                <hr/>
                <br/>
                <TournoisAffichageGestion userData={props.userData} tournoisEquipe={tournois.tournoisEquipe}/>
                <Card.Title as="h3" className="mb-0"><strong>Anciens tournois</strong></Card.Title>
                <hr/>
                <br/>
                <TournoisAffichageAncien userData={props.userData} ancienTournoiInscrit={tournois.ancienTournoiInscrit} ancienTournoiCreer={tournois.ancienTournoiCreer}/>
            </>
        ):(
        <>

        </> 
        )}
    </>
  );
};

export default TournoisAffichageCoach;
